import React, { useContext } from 'react';
import { CloseButton, StyledDialogTitle, StyledIcon } from '@components/dialog/main.dialog.title.styles';
import { DialogTitleProps, Icon, Typography } from '@material-ui/core';
import { DialogContext } from '@components/dialog/dialog.context';

export interface MainDialogTitleProps extends DialogTitleProps {
  icon?: string;
  hideCloseButton?: boolean;
}

export const MainDialogTitle = ({ icon, hideCloseButton, children, ...other }: MainDialogTitleProps) => {
  const context = useContext(DialogContext);
  const { onClose } = context;
  const showHideButton = onClose && !hideCloseButton;

  function onClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    if (onClose) onClose(e, 'backdropClick');
  }

  return (
    <StyledDialogTitle $hasIcon={!!icon} disableTypography {...other}>
      {icon && <StyledIcon>{icon}</StyledIcon>}
      <Typography variant='h6'>{children}</Typography>
      {showHideButton && (
        <CloseButton aria-label='close' onClick={onClick}>
          <Icon>close</Icon>
        </CloseButton>
      )}
    </StyledDialogTitle>
  );
};
